import React, { useState } from "react";
import style from "./index.module.scss";
import { getTopicType, TopicItem } from "service/exercise";
import TopicTypeAddModal from "../../../TopicTypeAddModal";
import useModalHandler from "utils/useModalHandler";
import { message } from "antd";
import { errorMessage } from "service/service";
import { SortableHandle } from "react-sortable-hoc";

interface TopicTypeListItemProps {
    id: string;
    descript: string;
    shareStatus: string;
    typeList: TopicItem[];
    topicTypOk: (id: string, description: string, basicTypeIds: string) => void;
}

export default function TopicTypeListItem({
    id,
    descript,
    shareStatus,
    typeList,
    topicTypOk
}: TopicTypeListItemProps) {
    const modal = useModalHandler();
    const [topicId, setTopicId] = useState("");
    const [description, setDescription] = useState(""); //题型名称
    const [basicTypeIds, setBasicTypeIds] = useState(""); //题型类型选项
    const [isHaveQuestion, setIsHaveQuestion] = useState(""); //题型下面是否有题0:没有1:有

    const Handle = SortableHandle(() => <span className={style.btnMove} />);

    function topicTypeAddOk(
        tid: string,
        description: string,
        basicTypeIds: string
    ) {
        //添加成功返回调用
        topicTypOk(tid, description, basicTypeIds);
        modal.close();
    }

    async function loadTopicItem(tid: string) {
        //查询试题详情
        try {
            const data = await getTopicType(tid);
            setTopicId(data.id);
            setBasicTypeIds(data.basicTypeIds);
            setDescription(data.description);
            setIsHaveQuestion(data.isHaveQuestion);
            modal.open();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <div className={style.root}>
            <div className={style.title} title={descript}>
                {descript}
            </div>

            {shareStatus.toString() === "1" && (
                <div className={style.tip}>系统内置题型</div>
            )}
            {shareStatus.toString() === "0" && <div className={style.tip} />}

            <div className={style.tools}>
                <Handle />
                <button
                    className={style.btnEdit}
                    onClick={() => loadTopicItem(id)}
                    disabled={shareStatus.toString() === "1"}
                />
                <button className={style.btnDel} disabled />
            </div>

            <TopicTypeAddModal
                visible={modal.visible}
                id={topicId}
                description={description}
                basicTypeIds={basicTypeIds}
                isHaveQuestion={isHaveQuestion}
                onOk={topicTypeAddOk}
                typeList={typeList}
                onCancel={modal.close}
            />
        </div>
    );
}
